import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DomainCacheService } from './domain-cache.service';

const baseRef = 'tipo-orgao';
const route = {
  listar: `${baseRef}`
};

@Injectable({
  providedIn: 'root'
})
export class TipoOrgaoService {

  constructor(
    private apiService: ApiService,
    private http: HttpClient,
    private domainCache: DomainCacheService
  ) { }

  listar(): Observable<any> {
    const key = `${route.listar}/combo`;
    return this.domainCache.getOrLoad(key, () =>
      this.apiService.get<any>(key, undefined, undefined, true)
    );
  }
}
